import {type BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export function getResourceCardData(): BaseCardData[] {
    return [
        {
            cardEnum: CardEnum.ResourceBack,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: true,
            clickPopupType: CardClickPopupType.None,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Lumber,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Brick,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Wool,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Grain,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        }, {
            cardEnum: CardEnum.Ore,
            cardTypeEnum: CardTypeEnum.Resource,
            isCardBack: false,
            clickPopupType: CardClickPopupType.TradeWindow,
            allowableTurnStates: undefined,
        },
    ]
}
